import { HttpMethod, HttpModel } from "@/Shared/domain";
import { CashbackAutoEnrollmentRepository } from "../domain/CashbackAutoEnrollmentRepository";
import { CashbackAcceptanceContext } from "../domain/CashbackModel";
import { axiosFetch } from "@/Shared/infrastructure";
import { getCashbackAutoEnrollmentAcceptance, getCashbackAutoEnrollmentStartTransaction } from "@/Shared/infrastructure/endpoints";
import { LogaltyModel } from "../domain";


export function createCashbackApiAutoEnrollmentRepository(): CashbackAutoEnrollmentRepository {
  return new ApiCashbackAutoEnrollmentRespository()
}

export class ApiCashbackAutoEnrollmentRespository implements CashbackAutoEnrollmentRepository {
  async startTransaction(userName: string): Promise<HttpModel<LogaltyModel>> {
    const response = await axiosFetch(getCashbackAutoEnrollmentStartTransaction, HttpMethod.GET, {userName})

    if (!response.data) {
      return {
        data: {} as LogaltyModel,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }
}